import axios from "axios";
// import Vue from "vue";

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  headers: {
    Accept: "application/json",
  },
  //   withCredentials: true
  // Custom flag: enables global loading by default
  withLoading: true,
});

// Interceptors
import axiosInterceptorsSetup from "../../interceptors/axios.interceptors";
axiosInterceptorsSetup(HTTP);

export default {
  get({ url, params, baseURL, headers, withLoading }) {
    const config = {
      baseURL,
      params,
      headers,
    };

    // Allow overriding global loading per request
    if (typeof withLoading === "boolean") {
      config.withLoading = withLoading;
    }

    return HTTP.get(url, config);
  },

  post({ url, data, baseURL, config, withLoading }) {
    const requestConfig = {
      baseURL,
      ...(config || {}),
    };

    // Allow overriding global loading per request
    if (typeof withLoading === "boolean") {
      requestConfig.withLoading = withLoading;
    }

    return HTTP.post(url, data, requestConfig);
  },

  put({ url, data, baseURL, id, withLoading }) {
    const config = {
      baseURL,
      headers: {},
    };

    // Allow overriding global loading per request
    if (typeof withLoading === "boolean") {
      config.withLoading = withLoading;
    }

    return HTTP.put(`${url}/${id}`, data, config);
  },

  delete({ url, baseURL, withLoading }) {
    const config = {
      baseURL,
      headers: {},
    };

    // Allow overriding global loading per request
    if (typeof withLoading === "boolean") {
      config.withLoading = withLoading;
    }

    return HTTP.delete(url, config);
  },

  patch({ url, data, baseURL, withLoading }) {
    const config = {
      baseURL,
      headers: {},
    };

    // Allow overriding global loading per request
    if (typeof withLoading === "boolean") {
      config.withLoading = withLoading;
    }

    return HTTP.patch(url, data, config);
  },

  async save({ url, data, baseURL, id, withLoading }) {
    if (id) {
      return await this.put({ url, id, data, baseURL, withLoading });
    } else {
      return await this.post({ url, data, baseURL, withLoading });
    }

    // Vue.swal({
    //   position: "top-end",
    //   icon: "success",
    //   title: "action executed successfully",
    //   showConfirmButton: false,
    //   timer: 2000
    // });
  },
};
